// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"43f78e05","745":"cc24581a","894":"43f78e05"}[chunkId] + ".chunk.css";
};